module.exports = __webpack_public_path__ + "static/media/trash-can.d558d5c5.svg";